<template>
<div id="course_intro">

	<div class="cover">
		<bgimage :src="course.cover"/>
	</div>
    
	<div class="caption">
		<span>{{course.name}}</span>
	</div>

	<div class="buttonWrapper">
		<button class="button" @click="click">{{$t('snippity.course.gotolessons')}}</button>
	</div>

	<div class="logowrapper">
        <logotype />
    </div>
</div>
</template>

<style scoped lang="sass">

#course_intro
	display: flex
	flex-flow: column
	justify-content: center
	align-items: center

	.buttonWrapper
		margin-top: 2 * $r

	.cover
		
		.bgimage
			border-radius: 90px
			width: 180px
			height: 180px

	.caption
		margin-top: 2 * $r
		text-align: center
		padding : 0 2 * $r
		max-width: 300px
		color : srgb(--neutral-grad-4)

		span
			font-size: 1.5em
			font-weight: 700

	.logowrapper
		margin-top: 2 * $r

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'course_intro',
	props: {
		course : Object
	},
	computed: mapState({
		auth: state => state.auth,
		userinfo: state => state.userinfo,
		progress : function(state){
            return state._progress[this.course.uid]
        }
	}),

	methods: {
		click : function(){
			this.$emit('cevent', {
				name : "tolessons"
			})
		}
	},
}
</script>
